/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from 'react-bootstrap';
import React, { useState, useEffect } from 'react';
import BaseModal from 'src/common/components/Modal';
import { filesAPI } from 'src/api/modules/files';
import FullTable from 'src/common/components/FullTable';
import { columnsRecord } from '../utils/list_data';
import notice from 'src/common/components/Notice';
import { startLog } from 'src/api/modules/bitacora';
import { Backdrop, CircularProgress } from '@material-ui/core';
import FileVersions from './components/FileVersions';
import { UploadFileMinos, download, downloadZip } from 'src/pages/Files/UpaloadFileMinos';
import { ZipComponentModal } from '../../ZipComponentModal';

const AddFiles = ({ open, setClose, order, user, canEdit, nameSesion }) => {
	//const [files, setFiles] = useState([]);
	const [uniques, setUniques] = useState([]);
	const [loader, setLoader] = useState(false);
	const [allFiles, setAllFiles] = useState([]);
	const [currentFile, setCurrentFile] = useState({});
	const [openHistory, setOpenHistory] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [fileDetail, setFileDetail] = useState([]);
	const [lastVersionFiles, setLastVersionFiles] = useState([]);

	const [descargados, setDescargados] = useState(0);
	const [totales, setTotales] = useState(0);
	const porcentaje = totales > 0 ? Math.round((descargados / totales) * 100) : 0;
	const [isDownloading, setIsDownloading] = useState(false);

	useEffect(() => {
		startLog(
			'Visualizo archivos adicionales del punto ' +
				order?.order +
				' de ' +
				nameSesion
		);

		setCurrentFile({
			idEntidad: order.id,
			tipo: 'A',
			entidad: 'ORDENDIA',
			ruta: 'Orden/' + order.id + '/',
			title: 'Archivo Orden Dia',
			nombre: '',
		});

		if (order !== 'undefined' && order !== undefined) getFiles();
	}, [order]);

	const getFiles = () => {
		setAllFiles([]);
		filesAPI
			.get('ORDENDIA', order.id, order.isMigrated, 'V')
			.then((response) => {
				// if (order.isMigrated === false) {
				// 	response = response.filter((e) => e.tipo === 'A');
				// }
				validateNumberedFiles(response, order.id);
			})
			.catch((e) => {
				notice('Ha ocurrido un error al cargar archivos adicionales');
			});
	};

	const validateNumberedFiles = (numberedFiles, orderID) => {
		let finalFiles = [];
		numberedFiles.forEach((item) => {
			finalFiles.push({
				...item,
				idFile: item.id,
				idFileMigrado: item.migrado ? item.idEntidad : undefined,
				idEntidad: item.migrado ? orderID : item.idEntidad,
				title: 'Archivo Orden Dia',
				fecha: new Date(item.fecha).toLocaleDateString(),
				hora: new Date(item.fecha).toLocaleString().split(',')[1],
				nombreOriginal: isNaN(Number(item.nombre.split('_')[0]))
					? item.nombre
					: item.nombre.slice(item.nombre.indexOf('_') + 1),
				nombreNumero: isNaN(Number(item.nombre.split('_')[0]))
					? '1_' + item.nombre
					: item.nombre,
				numeroFile: isNaN(Number(item.nombre.split('_')[0]))
					? 1
					: Number(item.nombre.split('_')[0]),
			});
		});

		//setFiles(finalFiles);
		let filesNumber = finalFiles.filter((e) => e.numeroFile === Number(e.numeroFile));

		let uniquesNames = [...new Set(filesNumber.map((u) => u.nombreOriginal))];

		getUpdateVersion(filesNumber, uniquesNames);
	};

	const getUpdateVersion = (finalFiles, uniquesNames) => {
		setUniques(uniquesNames);
		setAllFiles(finalFiles);

		let ultimaVersionFiles = [];
		uniquesNames.forEach(function (u) {
			let itemsFiles = finalFiles.filter((e) => {
				return e.nombreOriginal === u;
			});

			let obtenermayor = itemsFiles.sort((a, b) => {
				return Number(b.numeroFile) - Number(a.numeroFile);
			});

			ultimaVersionFiles.push(obtenermayor[0]);
		});

		setLastVersionFiles(ultimaVersionFiles);
		setLoader(false);
	};

	const onUploadedFile = () => {
		setLoader(true);
		setUniques([]);
		getFiles();
	};

	const onDownload = async (ruta) => {
		if (ruta.migrado === true) onDownloadMigrated(ruta);
		else
			download(
				ruta.ruta,
				ruta.nombre,
				user.nombre + ' ' + user.apellidoPaterno + ' ' + user.apellidoMaterno,
				false,
				'Archivos Adicionales del punto ' + order?.order + ' de ' + nameSesion,
				ruta.nombreOriginal
			);
	};

	const onDownloadMigrated = (file) => {
		filesAPI
			.DownloadFilesMigrated(file.idFileMigrado, file.versionArchivo)
			.then((response) => {
				let blob = response;
				let da = document.createElement('a');
				da.href = URL.createObjectURL(blob);
				da.setAttribute('download', file.nombre);
				da.click();
				URL.revokeObjectURL(da.href);
				notice('Se descargo el archivo con éxito', 'success');
			})
			.catch(() => {
				notice('Ha ocurrido un problema con la solicitud', 'error');
			});
	};

	const onDelete = (ruta) => {
		let mismoFile = allFiles.filter((e) => e.nombreOriginal === ruta.nombreOriginal);

		mismoFile.forEach((item, index) => {
			filesAPI
				.deleteFiles(item.idFile)
				.then(() => {
					if (index === mismoFile.length - 1) {
						notice('Archivo Eliminado con Exito', 'success');
						onUploadedFile();
					}
				})
				.catch((e) => {
					notice('Ha ocurrido un error al eliminar vesiones del archivo');
				});
		});
	};

	const onEye = (row) => {
		setFileDetail({
			name: row.nombreOriginal,
			orderNum: order.order,
			session: nameSesion,
		});
		setOpenHistory(true);
		startLog(
			'Visualizo historial de archivo del punto ' +
				order?.order +
				' de ' +
				nameSesion
		);
	};

	const downloadAll = async () => {
		setIsDownloading(true);
		setTotales(lastVersionFiles.length);
		downloadZip(
			lastVersionFiles,
			'',
			setIsLoading,
			order.order.toString().replace('.', '_'),
			false,
			setDescargados,
			setIsDownloading,
			descargados,
			setTotales
		);
	};

	return (
		<BaseModal
			open={true}
			onClose={setClose}
			onCancel={setClose}
			maxWidth="lg"
			cancelLabel="cerrar"
			mainText="Archivos Adicionales"
		>
			<div className="mb-8" style={{ fontSize: 15 }}>
				<b>Nombre del Punto: </b>
				{order.name}
			</div>
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
					gap: '5px',
				}}
			>
				{currentFile.idEntidad !== undefined ? (
					canEdit === true && (
						<UploadFileMinos
							control={
								<Button
									name="nombreFile"
									id={
										'BtnuploadMinos' +
										currentFile.idEntidad.toString() +
										currentFile.title.replaceAll(' ', '')
									}
									style={{ width: '70%' }}
									className=" btn-outline-primary "
								>
									Cargar Nuevo Archivo
								</Button>
							}
							onUploaded={onUploadedFile}
							idEntidad={currentFile.idEntidad}
							tipo={currentFile.tipo}
							entidad={currentFile.entidad}
							ruta={currentFile.ruta}
							title={currentFile.title}
							nombre={currentFile.nombre}
							idFile={currentFile.id}
							setOpen={setLoader}
							firstFile={true}
						/>
					)
				) : (
					<></>
				)}
				{isDownloading ? (
					<ZipComponentModal
						descargados={descargados}
						totales={totales}
						porcentaje={porcentaje}
					/>
				) : (
					<Button
						style={{ width: '28%', position: 'absolute', right: 30 }}
						disabled={isLoading ? true : false}
						onClick={
							isLoading
								? () => {}
								: () => {
										setIsLoading(true);
										downloadAll();
								  }
						}
						name="nombreFile"
					>
						{isLoading ? (
							<>
								<CircularProgress size={'10px'} color="secondary" />
							</>
						) : (
							'Descarga masiva'
						)}
					</Button>
				)}
			</div>
			<div className="mb-8"></div>
			{allFiles !== undefined && allFiles.length > 0 && (
				<FullTable
					title="Historial de Archivos"
					items={lastVersionFiles}
					columns={columnsRecord(
						onUploadedFile,
						onDownload,
						onDelete,
						onEye,
						canEdit,
						allFiles,
						uniques,
						setLoader
					)}
				/>
			)}
			{
				<Backdrop open={loader} style={{ zIndex: 1 }}>
					<CircularProgress color="secondary" />
				</Backdrop>
			}
			{openHistory && (
				<FileVersions
					user={user}
					open={openHistory}
					setClose={() => setOpenHistory(false)}
					fileDetail={fileDetail}
					pointData={order}
					downloadMigrated={onDownloadMigrated}
				/>
			)}
		</BaseModal>
	);
};

export default AddFiles;
